import { defineMessages } from 'react-intl'

const messages = defineMessages({
  yearAndUnit: {
    id: 'MapChart.yearAndUnit',
    description: 'Texto donde se muestra el año y la unidad en el MapChart',
    defaultMessage: 'Año {year} | Unidad: {unit}'
  },
  female: {
    id: 'MapChart.female',
    description: 'Texto para mujeres',
    defaultMessage: 'Mujeres'
  },
  male: {
    id: 'MapChart.male',
    description: 'Texto para hombres',
    defaultMessage: 'Hombres'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/MapChart/messages.js